
import { DOWNLOAD_SOFTWARE } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state == 'undefined') {
        state = [];
    }
    switch (action.type) {
        case DOWNLOAD_SOFTWARE.GET.INITIATE:
            return {isFetching: false};
        case DOWNLOAD_SOFTWARE.GET.SUCCESS:
            return {isFetching: true, data: action.payload};
        case DOWNLOAD_SOFTWARE.GET.ERROR:
            return action.payload;
        default:
            return state;
    }
};
